import React, { memo, useCallback, useMemo } from 'react';
import { ItemConsiderationBlockForm } from './ItemConsiderationBlock';
import { FormHTML } from '@core/components/form/FormHTML';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { CategoryResponse } from '@business/entities/category';
import { CommonService } from '@business/services';
import { R } from '@core/utils/r';
import { Button } from '@core/components/Button';
import { ProposalDisplayValueEnum } from '@business/entities/order';
import { CategoryItem } from './components/CategoryItem';
import { CategoryNoteItem } from './components/CategoryNoteItem';

export interface ItemConsiderationBlockSettingsProps {
  form: ItemConsiderationBlockForm;
  categories: CategoryResponse[];
  getCategoryImage: (categoryId: string) => any;
  updateCategoryImage: (categoryId: string, imageData: any) => void;
}

export const ItemConsiderationBlockSettings = memo((props: ItemConsiderationBlockSettingsProps) => {
  const { form, categories, getCategoryImage, updateCategoryImage } = props;

  const categoryItems = useMemo(
    () =>
      CommonService.selectItems(
        R.filter(categories, c => !c.parentId || c.parentId === '0'),
        c => c.title,
        'id',
      ),
    [categories],
  );

  const categoryNotesItems = useNonNilObservable(form.controls.categoryNotes.items$);
  const categoryItemsArray = useNonNilObservable(form.controls.categories.items$);

  const onAddCategory = useCallback(() => {
    const items = [
      {
        title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae nunc sed elit interdum tincidunt.',
        type: ProposalDisplayValueEnum.quantity,
        quantity: 1,
      },
      {
        title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae nunc sed elit interdum tincidunt.',
        type: ProposalDisplayValueEnum.bulletPoint,
        quantity: 1,
      },
      {
        title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae nunc sed elit interdum tincidunt.',
        type: ProposalDisplayValueEnum.none,
        quantity: 1,
      },
    ];
    const ctrl = form.controls.categories.push();
    ctrl.patchValue({
      items,
    });
  }, [form]);

  return (
    <div>
      <FormHTML veryMinimal control={form.controls.vccHeading} />

      {/* Category Image Settings */}
      <div className="mt-4">
        <div className="d-flex justify-content-between align-items-center">
          <h3>Categories</h3>
          <Button color="primary" outline size="small" onClick={() => onAddCategory()}>
            Add Category
          </Button>
        </div>
        {categoryItemsArray.map((categoryCtrl, categoryIndex) => (
          <CategoryItem
            key={categoryIndex}
            categoryCtrl={categoryCtrl}
            categoryIndex={categoryIndex}
            categoryItems={categoryItems}
            getCategoryImage={getCategoryImage}
            updateCategoryImage={updateCategoryImage}
            onDelete={() => form.controls.categories.removeAt(categoryIndex)}
          />
        ))}
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <h3 className="mt-4">Notes</h3>
        <Button color="primary" outline size="small" onClick={() => form.controls.categoryNotes.push()}>
          Add Note
        </Button>
      </div>
      {categoryNotesItems.map((ctrl, index) => (
        <CategoryNoteItem
          key={index}
          ctrl={ctrl}
          index={index}
          categoryItems={categoryItems}
          onDelete={() => form.controls.categoryNotes.removeAt(index)}
        />
      ))}
    </div>
  );
});
